<template>
    <div>
        <div v-if="type === 'input_text'">
            <p class="mb-1 f-90 fw-500">Input text</p>
            <b-form-input class="mb-1" v-model="structure.label" placeholder="입력폼 타이틀" @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트"
                          @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.placeholder" placeholder="텍스트 입력 가이드" @update="handleChange"/>
            <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트" @update="handleChange"/>
        </div>

        <div v-else-if="type === 'input_number'" class="">
            <p class="mb-1 f-90 fw-500">Input number</p>
            <b-form-input class="mb-1" v-model="structure.label" placeholder="입력폼 타이틀" @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트"
                          @update="handleChange"></b-form-input>
            <b-form-input class="mb-1" v-model="structure.placeholder" placeholder="텍스트 입력 가이드"
                          @update="handleChange"></b-form-input>
            <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트"
                          @update="handleChange"></b-form-input>
        </div>

        <div v-else-if="type === 'radio'">
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th class="bgray-100"> text</b-th>
                        <b-th class="bgray-100"> value</b-th>
                        <b-th class="bgray-100"> description</b-th>
                        <b-th class="bgray-100 text-center align-middle"> 삭제</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in structure" :key="item.id">
                        <b-td>
                            <b-form-input size="sm" v-model="item.text" @update="handleChange">{{
                                    item.text
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-input size="sm" v-model="item.value" @update="handleChange">{{
                                    item.value
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-checkbox v-model="is_description_available[index]"
                                             @input="manageDescriptionAvailability(item, index)" :value="true"
                                             :unchecked-value="false"
                            >
                                <b-input-group>
                                    <b-form-input :readonly="!is_description_available[index]"
                                                  size="sm"
                                                  placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요"
                                                  v-model="item.placeholder"
                                                  @update="handleChange"
                                    >
                                    </b-form-input>

                                    <template #append>
                                        <b-dropdown
                                            :text="item.description_input_type ? description_types[item.description_input_type] : '타입'"
                                            variant="dark" size="sm" :disabled="!is_description_available[index]"
                                        >
                                            <b-dropdown-item @click="setDescriptionType(index, 'text')">텍스트
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setDescriptionType(index, 'number')">숫자
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                            </b-form-checkbox>
                        </b-td>
                        <b-td>
                            <b-button @click="deleteRadioCheckboxItem(index)" class="" size="sm">
                                <fa icon="trash-alt"></fa>
                            </b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-button @click="addRadioCheckboxItem()" variant="blue" size="sm">라디오 선택지 추가</b-button>
            </div>
        </div>

        <div v-else-if="type === 'checkbox'">
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th class="bgray-100"> text</b-th>
                        <b-th class="bgray-100"> value</b-th>
                        <b-th class="bgray-100"> description</b-th>
                        <b-th class="bgray-100 text-center align-middle"> 삭제</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in structure" :key="item.id">
                        <b-td>
                            <b-form-input size="sm" v-model="item.text" @update="handleChange">{{
                                    item.text
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-input size="sm" v-model="item.value" @update="handleChange">{{
                                    item.value
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-checkbox v-model="is_description_available[index]"
                                             @input="manageDescriptionAvailability(item, index)" 
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                <b-input-group>
                                    <b-form-input :readonly="!is_description_available[index]"
                                                  size="sm"
                                                  placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요"
                                                  v-model="item.placeholder"
                                                  @update="handleChange"
                                    >
                                    </b-form-input>

                                    <template #append>
                                        <b-dropdown
                                            :text="item.description_input_type ? description_types[item.description_input_type] : '타입'"
                                            variant="dark" size="sm" :disabled="!is_description_available[index]"
                                        >
                                            <b-dropdown-item @click="setDescriptionType(index, 'text')">텍스트
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setDescriptionType(index, 'number')">숫자
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                            </b-form-checkbox>
                        </b-td>
                        <b-td>
                            <b-button @click="deleteRadioCheckboxItem(index)" class="" size="sm">
                                <fa icon="trash-alt"></fa>
                            </b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-button @click="addRadioCheckboxItem()" variant="blue" size="sm">체크박스 선택지 추가</b-button>
            </div>
        </div>

        <div v-else-if="type === 'table'">
            <p class="mb-2 f-90 fw-500">Table</p>

            <div class="mb-2">
                <p class="mb-2 f-85 fw-500">Table 제목</p>
                <b-form-input v-model="table_title"
                              placeholder="테이블 제목"
                              @update="handleChange"
                              class=""
                >
                    {{ table_title }}
                </b-form-input>
            </div>

            <div class="mb-2">
                table_description {{ table_description }}
                <p class="mb-2 f-85 fw-500">Table 설명</p>
                <b-form-input v-model="table_description"
                              placeholder="테이블 설명"
                              @update="handleChange"
                              class=""
                >
                    {{ table_description }}
                </b-form-input>
            </div>

            <div class="mb-2">
                <p class="mb-2 f-85 fw-500">Table Header</p>
                <b-form-input v-model="table_header"
                              placeholder="ex. 구분, 항목A, 항목B"
                              @update="handleChange"
                              class=""
                >
                    {{ table_header }}
                </b-form-input>
            </div>

            <p class="mb-2 f-85 fw-500">Table Body</p>
            <b-table-simple class="mb-2">
                <b-tbody>
                    <b-tr>
                        <b-th class="bgray-100"></b-th>
                        <b-th v-for="(col_item, col_idx) in table_header_col"
                              :key="`subs-${item_idx}-ele-${element_idx}-table-header-${col_idx}`"
                              class="bgray-100"
                        >
                            {{ col_item }}
                        </b-th>
                        <b-th class="bgray-100">관리</b-th>
                    </b-tr>
                    <b-tr v-for="(row_item, row_index) in structure" :key="row_item.id">
                        <b-td class="bgray-100"> {{ row_index + 1 }}</b-td>
                        <b-td v-for="(col_item, col_index) in table_header_col" :key="col_item.id">
                            <div @click.capture="editCell(row_item, col_item, row_index, col_index)">
                                <!-- {{ row_item }} -->
                                <template v-if="row_item.noteditables && row_item.noteditables.includes(col_item)">
                                    <div v-html="row_item[col_item]"/>
                                </template>
                                <template v-else-if="row_item.dropdown && row_item.dropdown[col_item]">
                                    <b-dropdown :id="`dropdown-${item_idx}-${element_idx}-${row_index}-${col_index}`"
                                                :text="row_item[col_item]"
                                                size="sm"
                                    >
                                        <b-dropdown-item v-for="drop_item in row_item.dropdown[col_item]"
                                                         :key="drop_item.id"
                                        >
                                            {{ drop_item }}
                                        </b-dropdown-item>
                                        <b-dropdown-item-button
                                            @click.capture="editCell(row_item, col_item, row_index, col_index)"
                                            style="font-size:0.8em; color:#FFFFFF; background-color:#0033FF"
                                        >
                                            수정
                                        </b-dropdown-item-button>
                                    </b-dropdown>
                                </template>
                                <template v-else-if="row_item.calculation && row_item.calculation[col_item]">
                                    <div>
                                        ( {{ row_item.calculation[col_item] }} )
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input v-model="row_item[col_item]"
                                                  readonly size="sm"
                                                  :placeholder="typeof row_item['placeholder'] !== 'undefined' && row_item['placeholder'][col_item] ? row_item['placeholder'][col_item] : null"
                                    />
                                </template>
                            </div>
                        </b-td>
                        <b-td>
                            <b-dropdown size="sm">
                                <b-dropdown-item-button @click="addDuplicatedRow(row_item, row_index)">
                                    복제
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="deleteRow(row_item, row_index)">
                                    삭제
                                </b-dropdown-item-button>
                            </b-dropdown>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-btn variant="info" size="sm" @click="addNewTableRow">새 행 추가</b-btn>
            </div>

        </div>

        <div v-else>
            <b-dropdown :text="type" :disabled="type !== '세부요소 선택'" variant="dark">
                <b-dropdown-item @click="selectType('input_text')">input_text</b-dropdown-item>
                <b-dropdown-item @click="selectType('input_number')">input_number</b-dropdown-item>
                <b-dropdown-item @click="selectType('checkbox')">checkbox</b-dropdown-item>
                <b-dropdown-item @click="selectType('radio')">radio</b-dropdown-item>
                <b-dropdown-item @click="selectType('table')">table</b-dropdown-item>
            </b-dropdown>
        </div>

        <!-- 셀 에디터 모달 -->
        <b-modal title="테이블 셀 설정"
                 :ref="`table-cell-editor-${item_idx}-${element_idx}`"
                 :id="`table-cell-editor-${item_idx}-${element_idx}`"
                 @ok="UpdateEditedCell($event)"
                 @hidden="initHandleCellEditor"
        >

            <b-form-select v-model="option_cell_selected" class="mb-3">
                <option value="input_text">텍스트 입력 폼</option>
                <option value="dropdown">드롭다운 선택지</option>
                <option value="text">수정불가 텍스트</option>
                <option value="calculation">계산식</option>
            </b-form-select>

            <!-- 텍스트 입력 폼일 경우 -->
            <template v-if="option_cell_selected == 'input_text'">
                <div class="d-flex justify-content-between editing-dfs">
                    기본 값
                    <b-form-input placeholder="미리 입력될 기본 값을 입력해주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>
            </template>
            <template v-if="option_cell_selected == 'input_text'">
                <div class="d-flex justify-content-between editing-dfs">
                    입력 유형
                    <b-form-select placeholder="입력 유형을 선택해주세요"
                                   v-model="editing_table.data.input_type[table_header_col[editing_table.col_index]]"
                                   class="w-75"
                                   :options="[
                            { value: 'text', text: '텍스트' },
                            { value: 'number', text: '숫자' }
                        ]"
                    />
                </div>

                <div class="d-flex justify-content-between editing-dfs">
                    가이드텍스트
                    <b-form-input placeholder="입력 가이드를 입력해주세요"
                                  v-model="editing_table.data.placeholder[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>
            </template>

            <!-- 드롭다운 선택지일 경우 -->
            <template v-if="option_cell_selected == 'dropdown'">
                <div class="mb-3 editing-dfs">
                    선택지
                    <b-form-input placeholder="선택지 항목을 쉼표로 구분하여 입력해주세요" v-model="dropdown"
                                  @update="updateCellDropdown(editing_table.data, table_header_col[editing_table.col_index], row_index, col_index)"
                    >
                    </b-form-input>
                </div>

                <div
                    class="d-flex justify-content-between align-items-center editing-dfs p-2 border border-color-gray-300 rounded f-90 ">
                    미선택시 기본 값:
                    <b-form-input placeholder="기본값을 입력해 주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>

            </template>

            <!-- 텍스트 선택지일 경우 -->
            <template v-if="option_cell_selected == 'text'">
                <div class="editing-dfs">
                    표시 텍스트
                    <b-form-input placeholder="셀에 직접 표시될 내용을 입력해 주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                    />
                </div>
            </template>

            <!-- 계산식일 경우 -->
            <template v-if="option_cell_selected == 'calculation'">
                <div class="editing-dfs">
                    계산식
                    <b-form-input :state="calculation_status" placeholder="계산식을 입력해 주세요(ex. A1+B1)"
                                  v-model="calculation_string"
                    />
                    {{ calculation_status_message }}
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import * as ih from '@core_utils/util'

export default {
    name: 'EditingDFElement',
    props: {
        item_idx: {
            type: Number
        },
        element_idx: {
            type: Number
        },
        element_item: {
            type: Object
        }
    },
    data() {
        return {
            type: '세부요소 선택',
            result: '',
            structure: [],
            table_title: '',
            table_description: '',
            table_header: '',

            is_description_available: [],
            description_types: {
                text: '텍스트',
                number: '숫자'
            },

            option_cell_selected: '',
            // alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],

            editing_table: {
                row_index: null,
                col_index: null,
                data: null
            },

            dropdown: '',

            calculation_string: '',
            calculation_validated_str: '',
            calculation_status: false,
            calculation_status_message: ''
        }
    },
    computed: {
        table_header_col: {
            get() {
                return ih.stringToArray(this.table_header)
            }
        }
    },
    created() {
        if (this.element_item.type) {
            this.type = this.element_item.type
        }

        this.result = this.element_item.result
        this.structure = JSON.parse(JSON.stringify(this.element_item.structure))

        if (this.type === 'table') {
            this.table_title = this.element_item.table_title
            this.table_description = this.element_item.table_description
            this.table_header = ih.arrayToString(this.element_item.table_header)
        }

        if (['checkbox', 'radio'].includes(this.type)) {
            this.initiateDescriptionAvailability()
        }
    },
    methods: {
        selectType(target) {
            this.structure = {}
            if (target === 'input_text' || target === 'input_number') {
                this.structure = {pre_text: '', after_text: '', placeholder: ''}
            } else if (['checkbox', 'radio'].includes(target)) {
                this.result = []
                this.structure = []
            } else if (target === 'table') {
                this.result = []
                this.structure = [{
                    '구분': '값',
                    dropdown: {},
                    placeholder: {},
                    input_type: {},
                    noteditables: [],
                    // calculation 이 빠져 있으면 저장 경로(generateSubcomponentDataBy)가 죽는다.
                    // 다른 표 기본값 3곳과 행 모양을 맞춘다.
                    calculation: {}
                }]
                this.table_header = '구분'
            }

            this.type = target
            this.handleChange()
        },
        addRadioCheckboxItem() {
            let new_radio_checkbox_item = {
                text: '',
                value: ''
            }
            this.structure.push(new_radio_checkbox_item)
            this.handleChange()
        },
        deleteRadioCheckboxItem(index) {
            this.structure.splice(index, 1)
            this.handleChange()
        },
        changeAttachmentCheckbox(item, field, value){
          this.$set(item, field, value) 
        },
        manageDescriptionAvailability(item, index) {
            this.$nextTick(() => {
                //해당 radio || checkbox 아이템에 대해 description을 쓴다고 체크한 것이면
                if (this.is_description_available[index] == true) {
                    this.$set(item, 'description_input_type', "text")
                    this.$set(item, 'description', "")
                    this.$set(item, 'placeholder', "")
                }
                //description을 쓰지 않는다고 체크한 것이면
                else {
                    delete item.description_input_type
                    delete item.placeholder
                    delete item.description
                }

                this.handleChange()

            })
        },
        initiateDescriptionAvailability() {
            for (let i = 0; i < this.structure.length; i++) {
                if(this.structure[i]['description_input_type']) {
                    this.is_description_available[i] = true
                } else {
                    this.is_description_available[i] = false
                }
            }
        },
        setDescriptionType(index, type) {
            this.$set(this.structure[index], 'description_input_type', type)
            this.handleChange()
        },
        editCell(row_item, col_item, row_index, col_index) {
            let _col_item = col_item

            if (_col_item !== this.table_header_col[col_index]) {
                _col_item = this.table_header_col[col_index]
            }

            this.option_cell_selected = 'input_text'
            let _rows = JSON.parse(JSON.stringify(row_item))
            if (_rows['dropdown'] != null && _rows.dropdown[_col_item]) {
                this.option_cell_selected = 'dropdown'
                this.dropdown = ih.arrayToString(_rows.dropdown[_col_item])
            } else if (_rows['calculation'] != null && _rows.calculation[_col_item]) {
                this.option_cell_selected = 'calculation'
                this.calculation_string = _rows.calculation[_col_item]
            } else if (_rows['noteditables'] != null && _rows.noteditables.includes(_col_item)) {
                this.option_cell_selected = 'text'
            } else if (this.option_cell_selected === 'input_text') {
                if (_rows['input_type'] == null) {
                    _rows["input_type"] = {}
                }

                if (_rows['input_type'][_col_item] == null) {
                    _rows["input_type"][_col_item] = 'number'
                }

                if (_rows['placeholder'] == null) {
                    _rows["placeholder"] = {}
                }

                if (_rows['placeholder'][_col_item] == null) {
                    _rows["placeholder"][_col_item] = "(숫자만 입력)"
                }
            }

            this.editing_table = {
                row_index: row_index,
                col_index: col_index,
                data: JSON.parse(JSON.stringify(_rows))
            }

            this.$nextTick(() => {
                this.$bvModal.show(`table-cell-editor-${this.item_idx}-${this.element_idx}`)
            })
        },
        initHandleCellEditor() {
            this.dropdown = []
            this.option_cell_selected = null
            this.calculation_string = null

            this.editing_table = {
                row_index: null,
                col_index: null,
                data: null
            }
        },
        UpdateEditedCell(bvModalEvt) {
            const _rows = {...this.editing_table.data}
            const col_item = this.table_header_col[this.editing_table.col_index]

            bvModalEvt.preventDefault()

            //순차적으로 판단하여 저장 전 cell 상태변경을 각 셀 데이터에 반영
            if (this.option_cell_selected === 'input_text') {
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }
            } else if (this.option_cell_selected === 'dropdown') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }

                if (!_rows.dropdown) _rows.dropdown = {}
                _rows.dropdown[col_item] = ih.stringToArray(this.dropdown)
            } else if (this.option_cell_selected === 'text') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (!_rows.noteditables) _rows.noteditables = []
                _rows.noteditables.push(col_item)
            } else if (this.option_cell_selected === 'calculation') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }

                if (this.calculation_status !== true) {
                    return false
                }

                if (!_rows.calculation) _rows.calculation = {}

                _rows.calculation[col_item] = this.calculation_validated_str
            } else {
                console.log('열행 번호에 맞는 내용이 없음')
            }

            this.$set(this.structure, this.editing_table.row_index, _rows)
            this.handleChange()

            this.$nextTick(() => {
                this.$bvModal.hide(`table-cell-editor-${this.item_idx}-${this.element_idx}`)
            })
        },
        updateCellDropdown(row_item, col_item) {
            this.$nextTick(() => {
                if (!row_item.dropdown) row_item.dropdown = {}
                row_item.dropdown[col_item] = ih.stringToArray(this.dropdown)
                this.handleChange()
            })
        },
        addNewTableRow() {
            const _new_table_row = {dropdown: {}, placeholder: {}, noteditables: [], input_type: {}}
            this.table_header.split(',').forEach(_header => {
                _new_table_row[_header] = ''
            });

            this.structure.push(_new_table_row)
            this.handleChange()
        },
        addDuplicatedRow(row_item, row_index) {
            let new_item = ih.deepCopy(row_item)
            this.structure.splice(row_index, 0, new_item)
            this.handleChange()
        },
        deleteRow(row_item, row_index) {
            this.structure.splice(row_index, 1)
            this.handleChange()
        },
        handleChange() {
            let new_item = {
                type: this.type,
                result: this.result,
                structure: this.structure
            }
            
            if (this.type == 'table') {
                if (this.table_title) {
                    new_item.table_title = this.table_title
                }

                if (this.table_description) {
                    new_item.table_description = this.table_description
                }

                new_item.table_header = ih.stringToArray(this.table_header)
            }

            this.$emit('change', this.item_idx, this.element_idx, new_item)
        },
    }
}
</script>
